import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { UsageCostRequestParams, useAnalyticsApi } from '../../../hooks'

import { DataSets, WidgetSpinner } from '../../common'
import { restructureDataSets } from './restructureDataSets'
import { useValidDataSetsOptions } from './useValidDataSetsOptions'

type UsageAndCostDataSetsProps = {
    activeDataSets: string[]
    setActiveDataSets: (dataSets: string[]) => void
    filters: UsageCostRequestParams
}

export const UsageAndCostDataSets: React.FC<UsageAndCostDataSetsProps> = ({
    activeDataSets,
    setActiveDataSets,
    filters,
}) => {
    const { useUsageCostQuery } = useAnalyticsApi()
    const validDataSetsOptions = useValidDataSetsOptions(filters)
    const { t } = useTranslation('translations')

    const { isLoading, isSuccess } = useUsageCostQuery(filters)

    const restructuredDataSets = restructureDataSets(validDataSetsOptions)

    if (isSuccess) {
        if (!restructuredDataSets.length || !activeDataSets.length) {
            return (
                <div className="flex h-full items-center justify-center">
                    <p
                        data-testid="no-datasets-message"
                        className="text-body-medium text-center text-subtle"
                    >
                        {t(
                            'analytics.usage_and_cost.data_sets_not_found.description'
                        )}
                    </p>
                </div>
            )
        }

        return (
            <DataSets
                options={restructuredDataSets}
                activeDataSets={activeDataSets}
                onChange={setActiveDataSets}
                filters={filters}
            />
        )
    }

    if (isLoading) {
        return (
            <div className="flex h-full items-center justify-center">
                <WidgetSpinner />
            </div>
        )
    }

    return (
        <div className="flex h-full items-center justify-center">
            <p
                className="text-body-medium text-center text-subtle"
                dangerouslySetInnerHTML={{
                    __html: t(
                        'analytics.usage_and_cost.data_sets_error.description'
                    ),
                }}
            />
        </div>
    )
}
